/* @ngInject */
function CampaignAttachmentsController ($rootScope, $scope, $window, $translate, $q, CampaignService, UdsModalService, AssetPreviewService) {
  const getAttachInsideTheModuleModalController = () =>
    $q.when(
      import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller')
    )
  $scope.visualization = 'grid'
  $scope.selectedAssets = []
  $scope.currentPage = 'campaign'

  const api = {
    getAttachInsideTheModuleModalController,
    _shouldShowEmptyState,
    _getCampaignAttachments,
    _openAttachAssetsDialog,
    _addAttachmentsToCampaign,
    _importFiles
  }

  $scope.emptyState = {
    shouldShowEmptyState: false,
    imgPath: 'campaign-attachment-empty-state',
    title: $translate.instant('campaignAttachments.emptyState.title'),
    message: $translate.instant('campaignAttachments.emptyState.message'),
    button: {
      type: 'primary',
      text: $translate.instant('campaignAttachments.emptyState.button.text'),
      icon: 'plus',
      click: api._openAttachAssetsDialog,
      disabled: $scope.campaign.status === 'FINISHED',
      tooltip: {
        text: $translate.instant('campaignErrors.campaignFinished'),
        position: 'bottom',
        disabled: $scope.campaign.status !== 'FINISHED'
      }
    }
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getCampaignAttachments($scope.campaign.id)
  }

  const deregisterSelectedAssets = $scope.$on('asset-card.update-selected-assets', (event, selectedAssets) => {
    $scope.selectedAssets = selectedAssets
  })

  const deregisterReloadAttachments = $rootScope.$on('campaign.reload-assets', (event) => {
    api._getCampaignAttachments($scope.campaign.id)
  })

  const deregisterAttachmentsAfterUpload = $rootScope.$on('campaign.add-attachments-to-campaign', (e, uploadedAssets) => {
    const assets = uploadedAssets.map(asset => asset.id)
    api._addAttachmentsToCampaign(assets, $scope.campaign.id)
  })

  $scope.$on('$destroy', () => {
    deregisterSelectedAssets()
    deregisterReloadAttachments()
    deregisterAttachmentsAfterUpload()
  })

  $scope.openAttachAssetsDialog = () => {
    api._openAttachAssetsDialog()
  }

  $scope.openPreview = async (asset) => {
    if (AssetPreviewService.assetPreviewIsOpen()) {
      return
    }

    if (!asset.assetId) {
      asset.isFolder = true
      localStorage.setItem('isFolder', true)
    }

    AssetPreviewService.openAssetPreview({
      asset: asset,
      location: 'campaignAttachment',
      getPreviewAssets: () => {
        return Promise.resolve({
          assets: $scope.attachments.rows || [],
          count: $scope.attachments.rows.length || 0
        })
      }
    })
  }

  function _openAttachAssetsDialog () {
    api.getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents'
        },
        onClose: assetsToAttach => {
          if (!assetsToAttach) {
            return
          }
          const assets = assetsToAttach.map(asset => asset.id)
          api._addAttachmentsToCampaign(assets, $scope.campaign.id)
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  function _importFiles () {
    $window.showOpenFilePicker({
      multiple: true
    }).then((filesInstances) => {
      if (!filesInstances?.length) {
        return
      }

      const mappedFiles = filesInstances.map((file) => file.getFile())
      return Promise.all(mappedFiles).then((files) => {
        $rootScope.$emit('upload-tab.upload-new-assets', files, { campaignId: $scope.campaign.id })
      })
    })
  }

  function _getCampaignAttachments (campaignId) {
    CampaignService.getCampaignAttachments({ campaignId })
      .then((attachments) => {
        $scope.attachments = {
          ...attachments,
          rows: attachments.rows.map((attachment) => ({
            ...attachment,
            campaignId: $scope.campaign.id
          }))
        }

        api._shouldShowEmptyState()
      })
  }

  function _addAttachmentsToCampaign (assets, campaignId) {
    CampaignService.addAttachmentsToCampaign({ assets, campaignId })
      .then(() => {
        api._getCampaignAttachments($scope.campaign.id)
      })
  }

  function _shouldShowEmptyState () {
    const attachmentsCount = $scope?.attachments?.rows?.length || 0

    $scope.emptyState.shouldShowEmptyState = attachmentsCount === 0
  }
}

export { CampaignAttachmentsController }
